<div class="fr-page-content fr-page-content--fullCenter">
  <fr-error-base>
    <span title>404 Page not found</span>
    <span description>The following url does not exist:</span>
    <span url>{{errorUrl || currentUrl}}</span>
  </fr-error-base>
</div>
